import React from 'react'
// import TPMS_2 from './TPMS_2'
import TPMS_1 from './TPMS_1'
// import TPMS_3 from './TPMS_3'
import TPMS_4 from './TPMS_4'
import TPMS_5 from './TPMS_5'
// import TPMS_6 from './TPMS_6'
import TPMS_7 from './TPMS_7'
import TPMS_8 from './TPMS_8'
import TPMS_FLOW from './TPMS_FLOW'
// import TPMS_11 from './TPMS_11'
import TPMS_FLOW1 from './TPMS_FLOW1'
import TPMS_Flow2 from './TPMS_Flow2'

import TPMS_FLow3 from './TPMS_FLow3'
// import TPMS_13 from './TPMS_13'
// import TPMS_14 from './TPMS_14'

// import TPMS_16 from './TPMS_16'
import Gfooter from '../Component/Gfooter'
import TPMS_17 from './TPMS_17'
// import TPMS_15 from './TPMS_15'
import TPMS_33 from './TPMS_33'
import TPMNoHardware from './TPMSNoHardware'
import Slider from './Slider'
import Coverflow_Slider from './Coverflow_Slider'
import TPMSFraud from './TPMSFraud'
import TPMSOperations from './Tpmsoperations'

function TPMS_Main() {
  return (
    <>
    <TPMS_1/>
    {/* <TPMS_2/> */}
    <TPMS_5/>
    {/* <TPMS_3/> */}
    <TPMS_33/>
    <TPMNoHardware/>
    <TPMS_4/>
    {/* <TPMS_6/> */}
    <TPMS_7/>
    {/* <TPMS_8/> */}
    {/* <TPMS_FLOW/> */}
    {/* <TPMS_FLOW1/> */}
    <TPMS_Flow2/>
    {/* <TPMS_13/> */}
    {/* <TPMS_FLow3/> */}
    
    {/* <TPMS_11/> */}
    
    <TPMS_17/>
    {/* <TPMS_14/> */}
    {/* <TPMS_15/> */}
    <TPMSFraud/>
    {/* <TPMS_16/> */}
    <TPMSOperations/>
    {/* <Slider/> */}
    {/* <Coverflow_Slider/> */}
    <Gfooter/>
    {/* <TPMS_12/> */}
    
    {/* <TPMS_10/> */}
    </>
  )
}

export default TPMS_Main
